import { UIDLUtils } from '@teleporthq/teleport-shared';
export const parseComponentJSON = (input, params = {}) => {
    const safeInput = params.noClone ? input : UIDLUtils.cloneObject(input);
    const node = safeInput.node;
    const result = {
        ...safeInput,
    };
    // other parsers for other sections of the component here
    result.node = parseComponentNode(node);
    return result;
};
export const parseProjectJSON = (input, params = {}) => {
    var _a, _b;
    const safeInput = params.noClone ? input : UIDLUtils.cloneObject(input);
    const root = safeInput.root;
    const result = {
        ...safeInput,
    };
    result.root = parseComponentJSON(root, { noClone: true });
    if ((_a = result.root) === null || _a === void 0 ? void 0 : _a.styleSetDefinitions) {
        const { styleSetDefinitions } = root;
        Object.values(styleSetDefinitions).forEach((styleRef) => {
            const { conditions = [] } = styleRef;
            styleRef.content = UIDLUtils.transformStylesAssignmentsToJson(styleRef.content);
            if (conditions.length > 0) {
                conditions.forEach((style) => {
                    style.content = UIDLUtils.transformStylesAssignmentsToJson(style.content);
                });
            }
        });
    }
    if ((_b = result.root) === null || _b === void 0 ? void 0 : _b.designLanguage) {
        const { tokens = {} } = result.root.designLanguage;
        result.root.designLanguage.tokens = Object.keys(tokens).reduce((acc, tokenId) => {
            const token = tokens[tokenId];
            if (typeof token === 'string' || typeof token === 'number') {
                acc[tokenId] = {
                    type: 'static',
                    content: token,
                };
            }
            else {
                acc[tokenId] = token;
            }
            return acc;
        }, {});
    }
    if (result.components) {
        result.components = Object.keys(result.components).reduce((parsedComponnets, key) => {
            parsedComponnets[key] = parseComponentJSON(result.components[key]);
            return parsedComponnets;
        }, {});
    }
    return result;
};
const parseComponentNode = (node) => {
    var _a, _b, _c;
    switch (node.type) {
        case 'element':
            const elementContent = node.content;
            if ((_a = elementContent) === null || _a === void 0 ? void 0 : _a.referencedStyles) {
                Object.values(elementContent.referencedStyles).forEach((styleRef) => {
                    var _a;
                    const { content } = styleRef;
                    if (content.mapType === 'inlined') {
                        content.styles = UIDLUtils.transformStylesAssignmentsToJson(content.styles);
                    }
                    if (content.mapType === 'project-referenced' && ((_a = content) === null || _a === void 0 ? void 0 : _a.conditions)) {
                        throw new Error(`
              We currently don't support conditions for "referencedStyles" which are
              "project-referenced". Because we need a solution to conditionally apply on the nodes
              with the condition they are being used.

              Eg: If a reference styles is used only for hover, we should be applying the style
              on hover of the node which is using it by pulling from project-style sheet.
            `);
                    }
                });
            }
            if (elementContent.style) {
                elementContent.style = UIDLUtils.transformStylesAssignmentsToJson(elementContent.style);
            }
            if (elementContent.attrs) {
                elementContent.attrs = UIDLUtils.transformAttributesAssignmentsToJson(elementContent.attrs);
            }
            // @ts-ignore
            if ((_b = elementContent.abilities) === null || _b === void 0 ? void 0 : _b.link) {
                // @ts-ignore
                const { content, type } = (_c = elementContent.abilities) === null || _c === void 0 ? void 0 : _c.link;
                if (type === 'url' && typeof content.url === 'string') {
                    content.url = UIDLUtils.transformStringAssignmentToJson(content.url);
                }
            }
            if (Array.isArray(elementContent.children)) {
                elementContent.children = elementContent.children.map((child) => {
                    if (typeof child === 'string') {
                        return UIDLUtils.transformStringAssignmentToJson(child);
                    }
                    else {
                        return parseComponentNode(child);
                    }
                }, []);
            }
            return node;
        case 'conditional':
            const conditionalNode = node;
            const { reference } = conditionalNode.content;
            conditionalNode.content.node = parseComponentNode(conditionalNode.content.node);
            if (typeof reference === 'string') {
                conditionalNode.content.reference = UIDLUtils.transformStringAssignmentToJson(reference);
            }
            return conditionalNode;
        case 'repeat':
            const repeatNode = node;
            const { dataSource } = repeatNode.content;
            repeatNode.content.node = parseComponentNode(repeatNode.content.node);
            if (typeof dataSource === 'string') {
                repeatNode.content.dataSource = UIDLUtils.transformStringAssignmentToJson(dataSource);
            }
            return repeatNode;
        case 'slot':
            const slotNode = node;
            if (slotNode.content.fallback) {
                slotNode.content.fallback = parseComponentNode(slotNode.content.fallback);
            }
            return slotNode;
        case 'dynamic':
        case 'static':
        case 'raw':
            return node;
        default:
            throw new Error(`parseComponentNode attempted to parsed invalid node type ${node.type}`);
    }
};
//# sourceMappingURL=index.js.map